module.exports = __webpack_public_path__ + "img/kyo_d200507b.2440afc6.jpg";